export default __webpack_public_path__ + "static/media/rotesmart.8dde01c2.png";